// src/components/SellerRegistration.js
import React, { useState, useEffect } from "react";
import "../styles/SellerRegistration.css";

export default function SellerRegistration({
  onSubmit,
  onCancel,
  initialEmail,
  initialContactName,
}) {
  const [form, setForm] = useState({
    shopName: "",
    contactName: "",
    email: "",
    phoneNumber: "",
    addressLine: "",
    city: "",
    state: "",
    pincode: "",
    primaryCategory: "",
    gstNumber: "",
  });

  const [error, setError] = useState("");

  // 🔹 Pre-populate email / contact name from logged-in user
  useEffect(() => {
    setForm((prev) => ({
      ...prev,
      email: initialEmail || prev.email,
      contactName: initialContactName || prev.contactName,
    }));
  }, [initialEmail, initialContactName]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!form.shopName || !form.contactName || !form.email) {
      setError("Please fill all required fields (Shop, Contact, Email)");
      return;
    }

    onSubmit(form);
  };

  return (
    <div className="seller-reg-overlay">
      <div className="registration-card">
        <div className="reg-header-row">
          <button className="back-btn" onClick={onCancel}>
            ← Back
          </button>
          <span className="reg-badge">Step 1 of 1 • Registration</span>
        </div>

        <h1 className="reg-title">
          <span role="img" aria-label="store">
            🏪
          </span>
          <span>Seller Registration</span>
        </h1>
        <p className="reg-subtitle">
          Join AuraKart as a fashion seller and start listing your products.
        </p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit} className="registration-form">
          {/* BASIC INFO */}
          <div className="form-section">
            <h3>Basic Information</h3>
            <p className="section-helper">
              These details will be visible to AuraKart admins for verification.
            </p>
            <div className="form-grid">
              <div className="form-group full-width">
                <label>
                  Shop Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="shopName"
                  value={form.shopName}
                  onChange={handleChange}
                  placeholder="Swathi Boutique"
                  required
                />
              </div>

              <div className="form-group">
                <label>
                  Contact Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="contactName"
                  value={form.contactName}
                  onChange={handleChange}
                  placeholder="Swathi"
                  required
                />
              </div>

              <div className="form-group">
                <label>
                  Email <span className="required">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="seller@example.com"
                  required
                  readOnly={!!initialEmail}
                  className={initialEmail ? "readonly-input" : ""}
                />
                {initialEmail && (
                  <span className="field-hint">
                    Email is taken from your Google login.
                  </span>
                )}
              </div>

              <div className="form-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  name="phoneNumber"
                  value={form.phoneNumber}
                  onChange={handleChange}
                  placeholder="+91 9876543210"
                />
              </div>
            </div>
          </div>

          {/* ADDRESS */}
          <div className="form-section">
            <h3>Shop Address</h3>
            <p className="section-helper">
              This helps us understand your serviceable locations.
            </p>
            <div className="form-group full-width">
              <label>Address Line</label>
              <input
                type="text"
                name="addressLine"
                value={form.addressLine}
                onChange={handleChange}
                placeholder="12 Cross Street, RS Puram"
              />
            </div>

            <div className="form-grid">
              <div className="form-group">
                <label>City</label>
                <input
                  type="text"
                  name="city"
                  value={form.city}
                  onChange={handleChange}
                  placeholder="Coimbatore"
                />
              </div>

              <div className="form-group">
                <label>State</label>
                <input
                  type="text"
                  name="state"
                  value={form.state}
                  onChange={handleChange}
                  placeholder="TN"
                />
              </div>

              <div className="form-group">
                <label>Pincode</label>
                <input
                  type="text"
                  name="pincode"
                  value={form.pincode}
                  onChange={handleChange}
                  placeholder="641002"
                />
              </div>
            </div>
          </div>

          {/* BUSINESS DETAILS */}
          <div className="form-section">
            <h3>Business Details</h3>
            <p className="section-helper">
              Share a bit about what you sell. You can edit these later.
            </p>
            <div className="form-grid">
              <div className="form-group">
                <label>Primary Category</label>
                <input
                  type="text"
                  name="primaryCategory"
                  value={form.primaryCategory}
                  onChange={handleChange}
                  placeholder="Kidswear / Sarees / Women’s Fashion"
                />
              </div>

              <div className="form-group">
                <label>GST Number</label>
                <input
                  type="text"
                  name="gstNumber"
                  value={form.gstNumber}
                  onChange={handleChange}
                  placeholder="33XYZAB1234D232"
                />
                <span className="field-hint">
                  Optional for now, but needed before payouts.
                </span>
              </div>
            </div>
          </div>

          {/* ACTIONS */}
          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="btn-primary">
              Submit Registration
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
